import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const FrontLayout = () => {
    return (
        <>
            <Helmet>
                {/* ----------- META ----------- */}
                <meta charSet="utf-8" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta
                    name="description"
                    content="The Sustain (Le SoutienPage) est une ONG chrétienne dédiée à la promotion de la foi, de la spiritualité, des bonnes œuvres, de la prière et de la parole de Dieu, en mettant l'accent sur la croyance en Jésus-Christ."
                />
                <meta
                    name="keywords"
                    content="foi chrétienne, spiritualité, prière, bonnes œuvres, parole de Dieu, Jésus-Christ, ONG chrétienne, soutien spirituel, développement spirituel, valeurs chrétiennes"
                />
                <meta name="author" content="Yem Mback Pierre" />

                {/* ----------- TITLE ----------- */}
                <title>
                    The Sustain | Soutien dans la foi chrétienne, la prière et les bonnes
                    œuvres
                </title>


            </Helmet>

            {/* ----------- CONTENT ----------- */}
            <main>
                <Outlet />
            </main>


        </>
    );
};

export default FrontLayout;
